export const REPORTS_V3_PDF_BASE_PATH = '/results-v3-pdf';
export const REPORTS_V3_EMBEDDABLE_BASE_PATH = '/results-v3-embeddable';
export const REPORTS_V3_BASE_PATH = '/results-v3';

type LocationDetails = {
  pathname: string;
  title: string;
};

enum ReportFlowPath {
  PRE_RESULTS_NOT_OPENED = 'PRE_RESULTS_NOT_OPENED',
  RESULTS_RELEASED = 'RESULTS_RELEASED',
  VIEW_RELEASED_RESULT = 'VIEW_RELEASED_RESULT',
}

// TODO: add results released flow path to the routes/reports flow
export const REPORT_FLOW_DETAILS: Record<ReportFlowPath, LocationDetails> = {
  [ReportFlowPath.PRE_RESULTS_NOT_OPENED]: {
    pathname: REPORTS_V3_BASE_PATH,
    title: 'Results are ready',
  },
  [ReportFlowPath.VIEW_RELEASED_RESULT]: {
    pathname: `${REPORTS_V3_BASE_PATH}/released-result`,
    title: 'Results',
  },
  // This route will be deprecated - use VIEW_RELEASED_RESULT instead
  [ReportFlowPath.RESULTS_RELEASED]: {
    pathname: '/results/hdr-59/report/next-steps',
    title: 'Results',
  },
};
